<div class="tool-bar flex flex-row justify-between items-center bg-transparent">
  <div class="logo-container">
    <a class="logo" href="/"></a>
  </div>
  @if (!openSearchBar) {
    <div class="header-right-group flex flex-row items-center gap-[12px]">
      @if (backToResultsUrl) {
        <div
          (click)="backToResults()"
          class="back-to-results flex flex-row items-center gap-[8px] h-[44px]"
          >
          <mat-icon svgIcon="back-arrow" class="back-icon"></mat-icon>
          <span>Back to search results</span>
        </div>
      }
      <div
        [@searchSlideAnimation]="'menu'"
        class="nav-panel flex flex-row justify-center items-end h-[44px] gap-[40px]"
        >
        <div
          (click)="navigate('/projects')"
          data-testid="nav-projects"
          [class.is-active]="currentPath === '/projects'"
          class="header-item "
          >
          Projects
        </div>
        @if (actingRole !== 'contractor-basic' && actingRole !== 'reviewer') {
          <div
            (click)="navigate('/reports')"
          data-testid="nav-reports"
            [class.is-active]="currentPath === '/reports'"
            class="header-item"
            >
            Reports
          </div>
        }
        @if (actingRole !== 'contractor-basic' && actingRole !== 'reviewer') {
          <div
            (click)="navigate('/organization')"
          data-testid="nav-organization"
            [class.is-active]="currentPath === '/organization'"
            class="header-item"
            >
            Organization
          </div>
        }
        @if (('update' | able: 'AppData')) {
          <div
            (click)="navigate('/app-settings')"
            [class.is-active]="currentPath === '/app-settings'"
            class="header-item"
            >
            App Settings
          </div>
        }
        @if (actingRole !== 'contractor-basic' && actingRole !== 'reviewer') {
          <div
            (click)="onSearchClick()"
            class="header-item"
            >
            <mat-icon [svgIcon]="'top-nav-search'" color="primary"></mat-icon>
          </div>
        }
        @if (authService.isLoggedIn()) {
          <div
            class="header-item"
            >
            <div [matMenuTriggerFor]="accountMenu">
              @if (!account.picture?.id) {
                <mat-icon [svgIcon]="'profile'"></mat-icon>
              }
              @if (account.picture?.id) {
                <img [src]="account.picture.getThumbnail()" alt="account-photo" class="icon-image"
                  title="{{ account.name }} photo" />
              }
            </div>
            <mat-menu #accountMenu class="account-menu">
              <div (click)="$event.stopPropagation()" class="account-info">
                @if (account.picture?.id) {
                  <div class="preview-list">
                    <div>
                      <img [src]="account.picture.getThumbnail()" alt="account-name-photo" title="{{ account.name }} photo" />
                    </div>
                  </div>
                }
                <div class="mat-subtitle-1">
                  {{ account.name }}
                  <a class="no-style link" href="/account/profile">
                    <mat-icon>settings</mat-icon>
                  </a>
                </div>
                <div class="mat-caption">{{ account.email }}</div>
                <div class="mat-caption">{{ account.phone }}</div>
              </div>
              <button (click)="logout()" mat-menu-item>
                <mat-icon>login</mat-icon>
                <span>Sign Out</span>
              </button>
            </mat-menu>
          </div>
        }
      </div>
      @if (authService.isLoggedIn() && isChatEnabled) {
        <button class="assistant-btn" (click)="openChat()" data-testid="header-assistant-btn">
          <mat-icon svgIcon="genai" class="assistant-icon"></mat-icon>
          <span>Assistant</span>
        </button>
      }
    </div>
  } @else {
    <div class="header-right-group flex flex-row items-center gap-[12px]">
      @if (backToResultsUrl) {
        <div
          (click)="backToResults()"
          class="back-to-results flex flex-row items-center gap-[8px] h-[44px]"
          >
          <mat-icon svgIcon="back-arrow" class="back-icon"></mat-icon>
          <span>Back to search results</span>
        </div>
      }
    <div
      [@searchSlideAnimation]="'search'"
      [class.is-closed]="form?.controls?.searchText?.value <= 3"
      [class.is-open]="isOpen"
      class="search-panel flex flex-row justify-center items-end h-[44px] gap-[40px]"
      >
      <div
        #trigger="cdkOverlayOrigin"
        cdkOverlayOrigin
        class="search-wrapper"
        >
        <form
          [formGroup]="form"
          >
          <div class="search-section">
            <div
              [class.is-closed]="form?.controls?.searchText?.value <= 3"
              [class.is-open]="isOpen"
              class="search"
              >
              <mat-icon (click)="search()" svgIcon="search"></mat-icon>
              <input
                #searchInput
                class="search-input"
                formControlName="searchText"
                matInput
                placeholder="Search"
                >
              <mat-icon
                (click)="close()"
                svgIcon="close"
              ></mat-icon>
            </div>
          </div>
        </form>
      </div>
      <ng-template
        (backdropClick)="dismissPreview()"
        [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
        [cdkConnectedOverlayHasBackdrop]="isOpen"
        [cdkConnectedOverlayOpen]="isOpen"
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayPanelClass]="'custom-search-backdrop'"
        cdkConnectedOverlay
        >
        @if (isOpen && form?.controls?.searchText?.value) {
          <div class="search-result-popup">
            @if (searchResultsLoading) {
              <div class="search-result-filter-item">
                <div class="loading flex flex-row justify-center items-center gap-[10px] px-[16px]">
                  <mat-spinner color="primary" diameter="20" mode="indeterminate" strokeWidth="3" />
                  <span>Loading</span>
                </div>
              </div>
            } @else {
              @if (searchResultsList?.length > 0 && !searchResultsLoading) {
                <div class="search-result-filter-list">
                  @for (eachSearchResults of previewResults; track eachSearchResults) {
                    <div
                      (click)="openCategory(eachSearchResults)"
                      class="search-result-filter-item overflow-hidden"
                      >
                      <div class="flex flex-row justify-start items-center gap-[16px]">
                        <div class="left flex flex-col justify-center items-center">
                          <mat-icon
                            [svgIcon]="iconFor(eachSearchResults)"
                            class="icon"
                            />
                        </div>
                        <div class="right flex flex-col justify-center grow">
                          <div class="each-search-result ">
                            <div class="daily-report-wrapper w-full">
                              <div class="daily-report-heading text-type-6 !leading-[24px]">
                                {{ titleFor(eachSearchResults) }}
                              </div>
                              <div class="daily-report-sub-heading text-type-14 !text-[#060b1e]">
                                {{ subHeadingFor(eachSearchResults) }}
                              </div>
                              @if (matchInfoFor(eachSearchResults)) {
                                <div class="match-info text-type-14">
                                  {{ matchInfoFor(eachSearchResults) }}
                                </div>
                              }
                              @if (matchedHintHtmlFor(eachSearchResults)) {
                                <div [innerHTML]="matchedHintHtmlFor(eachSearchResults)" class="match-info text-type-14">
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                <div
                  (click)="seeAllResults()"
                  class="search-result-filter-item justify-center
                      text-center px-[16px] text-type-13 !text-[#1036d6]"
                  >
                  See all results
                </div>
              </div>
            } @else {
              <div class="search-result-filter-item px-[16px]">
                No Search Result Found
              </div>
            }
          }
        </div>
      }
    </ng-template>
  </div>
  </div>
}
</div>


